module.exports = "Radio buttons (`ChoiceGroup`) let people select a single option from two or more choices.\n"